// TODO: Hate the name of this file and everything in it, but Jacob will intuitively know the perfect solution for this
import Cookies from 'js-cookie';

import { COOKIE_NAME_HAS_AUTH, COOKIE_NAME_HAS_CART } from './constants.ts';

/**
 * Checks whether there is an existing cart session.
 *
 * NOTE: Might want to consolidate these into one utility.
 */
export const hasCart = () => !!Cookies.get(COOKIE_NAME_HAS_CART);

/**
 * Checks whether there is an existing supporter session.
 */
export const hasAuth = () => !!Cookies.get(COOKIE_NAME_HAS_AUTH);
